// Angular
import {Provider} from '@angular/core';

import {PrefixStoreService} from './prefix-store.service';
import {RegistrationStoreService} from './registration-store.service';

const storeServices = [
  PrefixStoreService,
  RegistrationStoreService,
];

export const storeProviders: Provider[] = [
  ...storeServices,
];
